module.exports = {"210113001":"新城子街道","210113002":"清水台街道","210113003":"辉山街道","210113004":"道义街道","210113006":"虎石台街道","210113007":"财落街道","210113009":"沈北街道","210113010":"马刚街道","210113011":"石佛寺街道","210113012":"黄家街道","210113013":"尹家街道","210113014":"兴隆台街道","210113015":"清泉街道","210113401":"青年农场","210113402":"前进农场","210113403":"育新农场","210113404":"沈北新区马刚林场","210113405":"沈北新区示范农场","210113406":"沈北新区种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210113.json
// module id = 459
// module chunks = 0